import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionTransitionDetails } from '../models/session-transition-details';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class SessionAuditService {

  constructor(private httpClient:HttpClient) { }

  
  getSessionTransitionDetails = (sessionId: string):
    Observable<SessionTransitionDetails> => {
    return this.httpClient.get<SessionTransitionDetails>(
      ApiConstants.Session_Transition_Details_Api +
      '/' +
      `${sessionId}`,
    );
  }
}
